module.exports = __webpack_public_path__ + "img/friendly-activities.102398c6.jpg";